export enum CABINETS_ROUTES {
  GET_CABINET_STAFF = "/workspace/users/staff",
  GET_CABINET_STAFF_MEMBER = "/workspace/users/staff/:userId",
  ADD_STAFF = "/workspace/users/register",
  UPDATE_STAFF = "/workspace/users/staff/:userId",
  REMOVE_STAFF = "/workspace/users/staff",
  GET_CABINET_SUB_HISTORY = "/workspace/settings/payments",
  GET_SUBSCRIPTION_STATUS = "/workspace/settings/sub-status",
  GET_SUBSCRIPTION_LINK = "/workspace/settings/sub-link",
}
